window.requestAnimFrame = (function() {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function(callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();

export const scrollToTop = function() {
  const tick = function() {
    if (window.scrollY !== 0) {
      window.scrollTo(0, window.scrollY - 45);
      window.requestAnimFrame(tick);
    }
  };
  tick();
};

/**
 *
 * @param {*} url
 *
 * extractHostname('http://www.blog.classroom.me.uk/index.php')
 * extractHostname('http://www.youtube.com/watch?v=ClkQA2Lb_iE')
 * extractHostname('https://www.youtube.com/watch?v=ClkQA2Lb_iE')
 * extractHostname('www.youtube.com/watch?v=ClkQA2Lb_iE')
 * extractHostname('ftps://ftp.websitename.com/dir/file.txt')
 * extractHostname('websitename.com:1234/dir/file.txt')
 * extractHostname('ftps://websitename.com:1234/dir/file.txt')
 * extractHostname('example.com?param=value')
 */
export const extractHostname = function(url) {
  const a = document.createElement('a');
  a.href = url;
  return a.protocol + '//' + a.hostname;
};
